import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl = `${environment.apiUrl}/reports`;

  /** Submit a report against a post / blog / event. */
  submitReport(contentId: string, description: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(this.baseUrl, { contentId, description });
  }

  /** Submit a report against a comment / reply. */
  submitCommentReport(commentId: string, description: string): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.post(`${this.baseUrl}/comments`, { commentId, description });
  }
}
